<template>
    <div>

        <rkm-area
            title="Cota"
            no-margin-top
        >

            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                slot="trailing"
                small
                title="Adicionar cota"
            >
                <rkm-icon icon="plus" />
            </rkm-button>

            <rkm-table
                :items="dados"
                :fields="fields.tables.tipo"
                :filter="filter"
                sort-by="nomeFantasia"
            >

                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                          <rkm-form-select
                                :options="data.form.anos"
                                show-default-option
                                default-option-text="Selecione o ano"
                                text-field="cotaAno"
                                v-model="model.cotaAno"

                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.cotaMes"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter && !model.cotaMes && !model.cotaAno"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(actions)="{ index, item }">
                    <rkm-button
                        @click="$refs.Modal.open(index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="handleCota(index, item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

           <Modal
                :data="data"
                ref="Modal"
            />
        </rkm-area>

        <rkm-area
            title="TRANSFERÊNCIA"
            class="mt-3"
        >
            <rkm-button
                @click="$refs.ModalTransferencia.open()"
                color="primary"
                slot="trailing"
                small
                title="Realizar transferência"
            >
                <rkm-icon icon="plus" />
            </rkm-button>

            <rkm-table
                :items="dadosTransferencia"
                :fields="fields.tables.transferencia"
                :filter="filterTransferencia"
                sort-by="origemNomeFantasia"
            >

                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filterTransferencia"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.anos"
                                show-default-option
                                default-option-text="Selecione o ano"
                                text-field="cotaAno"
                                v-model="model.transferenciaAno"

                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.transferenciaMes"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filterTransferencia && !model.transferenciaMes && !model.transferenciaAno"
                                @click="handleClearFilterTransferencia"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(actions)="{ index, item }">
                    <rkm-button
                        @click="$refs.ModalTransferencia.open(index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroyTransferencia(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

           <ModalTransferencia
                :data="data"
                :transferenciaLaboratorio="model.transferenciaLaboratorio"
                ref="ModalTransferencia"
            />
        </rkm-area>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Modal from './Modal'
import ModalTransferencia from '../transferencia/Modal'

// Moment.
import moment from 'moment'

// Mixins.
import { repository, object, data, error, formats } from '@/mixins'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

export default {
    components: { Modal, ModalTransferencia },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'nomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'valorUnidade', label: 'Valor', class: 'col-min text-center', sortable: true },
                        { key: 'valorUtilizado', label: 'Utilizado (valor)', class: 'col-min text-center', sortable: true },
                        { key: 'valorSaldo', label: 'Saldo (valor)', class: 'col-min text-center', sortable: true },
                        { key: 'quantidadeUnidade', label: 'Quantidade', class: 'col-min text-center', sortable: true },
                        { key: 'quantidadeUtilizada', label: 'Utilizada (quantidade)', class: 'col-min text-center', sortable: true },
                        { key: 'quantidadeSaldo', label: 'Saldo (quantidade)', class: 'col-min text-center', sortable: true },
                        { key: 'ano', label: 'Ano', class: 'text-center', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                    transferencia: [
                        { key: 'origemNomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'origemInfraestrutura', label: 'Local de atendimento', sortable: true },
                        { key: 'valorUnidade', label: 'Valor', sortable: true },
                        { key: 'quantidadeUnidade', label: 'Quantidade', sortable: true },
                        { key: 'ano', label: 'Ano', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
        dados() {

            const ano = this.model.cotaAno
            const mes = this.model.cotaMes

            return this.itemsUnidadeSolicitante.map(unidade => {

                let valorUnidade = 0
                let quantidadeUnidade = 0
                let valorUtilizado = 0
                let quantidadeUtilizada = 0

                if (unidade.cotaUnidadeSolicitante) {

                    valorUnidade = unidade.cotaUnidadeSolicitante.filter(field =>
                        field.cotaTipoId == this.enums.tipoCota.VALOR)

                    quantidadeUnidade =  unidade.cotaUnidadeSolicitante.filter(field =>
                        field.cotaTipoId == this.enums.tipoCota.QUANTIDADE)

                    if (ano != null) {
                        valorUnidade = valorUnidade.filter(field => field.periodo.start.substr(6, 4) == ano)
                        quantidadeUnidade = quantidadeUnidade.filter(field => field.periodo.start.substr(6, 4) == ano)
                    }

                    if (mes != null) {
                        valorUnidade = valorUnidade.filter(field => field.periodo.start.substr(3, 2) == mes)
                        quantidadeUnidade = quantidadeUnidade.filter(field => field.periodo.start.substr(3, 2) == mes)
                    }

                    valorUtilizado = valorUnidade.reduce((sum, element) => sum + this.formatSumMoney(element.valorUtilizado), 0);
                    valorUnidade = valorUnidade.reduce((sum, element) => sum + this.formatSumMoney(element.cotaValor), 0);

                    quantidadeUtilizada = quantidadeUnidade.reduce((sum, element) => {

                        if (element.quantidadeUtilizada) {
                            sum = sum + Number(element.quantidadeUtilizada);
                        }

                        return sum;
                    },0)

                    quantidadeUnidade = quantidadeUnidade.reduce((sum, element) => {

                        if (element.cotaQuantidade) {
                            sum = sum + Number(element.cotaQuantidade);
                        }

                        return sum;
                    },0)
                }

                let transferencia = 0
                let transferenciaValor = 0
                let transferenciaRecebida = 0
                let transferenciaRecebidaValor = 0

                if (unidade.cotaUnidadeSolicitante) {

                    unidade.cotaUnidadeSolicitante.map(item => {

                        const cota = this.data.model.cotasTransferencia.find((obj =>
                            obj.origemUnidadeId == unidade.unidadeId
                            && obj.origemInfraestruturaId == unidade.infraestruturaId
                            && obj.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE
                        ));

                        if (cota) {

                            let cotaTransferencia = cota.destino.filter(i => i.origemCotaTipoId == item.cotaTipoId)

                            if (ano != null) {
                                cotaTransferencia = cotaTransferencia.filter(field =>
                                    field.origemInicio.substr(6, 4) == ano
                                    && field.origemFim.substr(6, 4) == ano)
                            }

                            if (mes != null) {
                                cotaTransferencia = cotaTransferencia.filter(field =>
                                    field.origemInicio.substr(3, 2) == mes
                                    && field.origemFim.substr(3, 2) == mes)
                            }

                            let valorUnidade = cotaTransferencia
                                .filter(field => field.origemCotaTipoId == this.enums.tipoCota.VALOR)
                                .reduce((sum, element) => sum + this.formatSumMoney(element.destinoCotaValor), 0);

                            let quantidadeTransferido = cotaTransferencia
                                .filter(field => field.origemCotaTipoId == this.enums.tipoCota.QUANTIDADE)
                                .reduce((sum, element) => {

                                    if (element.destinoCotaQuantidade) {
                                        sum = sum + Number(element.destinoCotaQuantidade);
                                    }

                                    return sum;
                                },0)

                            cotaTransferencia.map(exame => {

                                let cotaExameQuantidade = exame.exames
                                    .reduce((sum, element) => {

                                        if (element.transferido && element.cotaQuantidadeTransferido) {
                                            sum = sum + Number(element.transferido);
                                        }

                                        return sum;
                                    },0)

                                quantidadeTransferido = quantidadeTransferido + cotaExameQuantidade

                                let cotaExameValor = exame.exames
                                    .filter(field => field.cotaValorTransferido > '0,00')
                                    .reduce((sum, element) => sum + this.formatSumMoney(element.transferido), 0);

                                valorUnidade = this.formatMoney(valorUnidade, 2)
                                cotaExameValor = this.formatMoney(cotaExameValor, 2)

                                valorUnidade = this.formatSumMoney(valorUnidade) + this.formatSumMoney(cotaExameValor)
                                valorUnidade = this.formatMoney(valorUnidade, 2)
                            })

                            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                                transferenciaValor = valorUnidade
                            } else {

                                transferencia = quantidadeTransferido
                            }
                        }

                        let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                            field.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE)

                        if (transferenciaLaboratorio.length > 0) {

                            transferenciaLaboratorio = transferenciaLaboratorio.map(field => field.destino)

                            Object.keys(transferenciaLaboratorio).forEach(cota => {

                                let recebidos = transferenciaLaboratorio[cota]
                                    .filter(i => i.destinoUnidadeId == unidade.unidadeId
                                        && i.destinoInfraestruturaId == unidade.infraestruturaId
                                        && i.origemCotaTipoId == item.cotaTipoId
                                        && moment(
                                            i.destinoInicio.split("/").reverse().join("-"),
                                        )
                                        .isBetween(
                                                item.periodo.start.split("/").reverse().join("-"),
                                                item.periodo.end.split("/").reverse().join("-"),
                                            null,
                                            '[]'
                                        )

                                        || i.destinoUnidadeId == item.unidadeId
                                            && i.destinoInfraestruturaId == item.infraestruturaId
                                            && i.origemCotaTipoId == item.cotaTipoId
                                            && moment(
                                                i.destinoFim.split("/").reverse().join("-")
                                            )
                                            .isBetween(
                                                item.periodo.start.split("/").reverse().join("-"),
                                                item.periodo.end.split("/").reverse().join("-"),
                                                null,
                                                '[]'
                                            )
                                    )

                                if (ano != null) {
                                    recebidos = recebidos.filter(field =>
                                        field.destinoInicio.substr(6, 4) == ano
                                        && field.destinoFim.substr(6, 4) == ano)
                                }

                                if (mes != null) {
                                    recebidos = recebidos.filter(field =>
                                        field.destinoInicio.substr(3, 2) == mes
                                        && field.destinoFim.substr(3, 2) == mes)
                                }

                                recebidos.forEach(recebido => {

                                    if (recebido.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                                        transferenciaRecebidaValor = this.formatMoney(transferenciaRecebidaValor, 2)

                                        transferenciaRecebidaValor = this.formatSumMoney(transferenciaRecebidaValor) +
                                            this.formatSumMoney(this.getCotaExame(recebido))

                                        transferenciaRecebidaValor = this.formatMoney(transferenciaRecebidaValor, 2)
                                    } else {

                                        transferenciaRecebida = transferenciaRecebida + this.getCotaExame(recebido)
                                    }
                                });
                            })
                        }
                    })
                }

                quantidadeUnidade = (quantidadeUnidade - transferencia) + transferenciaRecebida

                let quantidadeSaldo = quantidadeUnidade - quantidadeUtilizada

                valorUnidade = this.formatMoney(valorUnidade, 2)
                transferenciaValor = this.formatMoney(transferenciaValor, 2)
                transferenciaRecebidaValor = this.formatMoney(transferenciaRecebidaValor, 2)

                valorUnidade = (this.formatSumMoney(valorUnidade) - this.formatSumMoney(transferenciaValor))
                    + this.formatSumMoney(transferenciaRecebidaValor)

                let valorSaldo = parseFloat(valorUnidade) - parseFloat(valorUtilizado)

                return {
                    nomeFantasia: unidade.nomeFantasia,
                    infraestruturaNome: unidade.infraestruturaNome,
                    infraestruturaId: unidade.infraestruturaId,
                    unidadeId: unidade.unidadeId,
                    valorUnidade:this.formatMoney(valorUnidade, 2),
                    valorUtilizado:this.formatMoney(valorUtilizado, 2),
                    valorSaldo:this.formatMoney(valorSaldo, 2),
                    quantidadeUnidade: this.formatMoney(quantidadeUnidade, 0),
                    quantidadeUtilizada: this.formatMoney(quantidadeUtilizada, 0),
                    quantidadeSaldo: this.formatMoney(quantidadeSaldo, 0),
                    ano: this.model.cotaAno,
                }
            })
        },
        dadosTransferencia() {

            const ano = this.model.transferenciaAno
            const mes = this.model.transferenciaMes

            let filterItems = this.itemsCotasTransferenciaUnidade.map(unidade => {

                let valorUnidade = unidade.destino
                let quantidadeUnidade =  unidade.destino

                if (ano != null) {

                    valorUnidade = valorUnidade.filter(field => field.origemInicio.substr(6, 4) == ano)
                    quantidadeUnidade = quantidadeUnidade.filter(field => field.origemInicio.substr(6, 4) == ano)
                }

                if (mes != null) {

                    valorUnidade = valorUnidade.filter(field => field.origemInicio.substr(3, 2) == mes)
                    quantidadeUnidade = quantidadeUnidade.filter(field => field.origemInicio.substr(3, 2) == mes)
                }

                valorUnidade = valorUnidade.reduce((sum, element) => sum + this.formatSumMoney(element.destinoCotaValor), 0);

                quantidadeUnidade =  quantidadeUnidade.reduce((sum, element) => {

                        if (element.destinoCotaQuantidade) {
                            sum = sum + Number(element.destinoCotaQuantidade);
                        }

                    return sum;
                },0)

                return {
                    id: unidade.id,
                    laboratorioUnidadeId: unidade.laboratorioUnidadeId,
                    laboratorioInfraestruturaId: unidade.laboratorioInfraestruturaId,
                    origemUnidadeId: unidade.origemUnidadeId,
                    origemInfraestruturaId: unidade.origemInfraestruturaId,
                    destino: unidade.destino,
                    laboratorioNomeFantasia: unidade.laboratorioNomeFantasia + ' - ' + unidade.laboratorioInfraestrutura,
                    origemNomeFantasia: unidade.origemNomeFantasia,
                    origemInfraestrutura: unidade.origemInfraestrutura,
                    valorUnidade: this.formatMoney(valorUnidade, 2),
                    quantidadeUnidade: this.formatMoney(quantidadeUnidade, 0),
                    ano: this.model.transferenciaAno,
                }
            })

            return filterItems
        },
    },
    data: () => ({
        items: [],
        enums: {
            tipoUnidade,
            tipoCota,
        },
        model:{
            cotaAno: null,
            cotaMes: null,
            transferenciaAno: null,
            transferenciaMes: null,
            transferenciaLaboratorio: false,
        },
        filter: null,
        filterTransferencia: null,
        cotasAtribuidas: 0,
        cotaAtribuida: 0
    }),
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.cotaAno = moment().format("YYYY")
            this.model.transferenciaAno = moment().format("YYYY")
        },
        handleCota(index, item) {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                solicitante_infraestrutura_id: item.infraestruturaId,
            })
                .then(response => {

                    if (response.data.valorAgendado == 0 || response.data.quantidadeAgendada == 0) {

                        this.handleDestroy(index, item)
                    } else {

                        const unidade = this.data.form.unidades.find(u => u.id === item.unidadeId)
                        const infraestrutura = unidade.infraestruturas.find(u => u.id === item.infraestruturaId)

                        this.showValidationNotification(`Não é possível excluir a cota da unidade
                            <strong>${ unidade.nomeFantasia }</strong> e o local de atendimento
                            <strong>${ infraestrutura.nome }</strong>, pois já possui agendamentos vinculados a ela.`)

                        return false
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(index, item) {

            this.getCotaAtribuida(item)

            if (this.cotasAtribuidas > 0) {

                const unidade = this.data.form.unidades.find(u => u.id === item.unidadeId)
                const infraestrutura = unidade.infraestruturas.find(u => u.id === item.infraestruturaId)

                this.showValidationNotification(`Não é possível excluir a unidade <strong>${ unidade.nomeFantasia }</strong> e o local de atendimento
                    <strong>${ infraestrutura.nome }</strong>, pois já possui cotas atribuídas.`)

                return false
            }

            const destroy = async () => this.data.model.cotasUnidadeSolicitante.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a cota da unidade solicitante?', destroy)
        },
        handleDestroyTransferencia(item) {

            const objIndex = this.data.model.cotasTransferencia.findIndex((obj => obj.unidadeId == item.unidadeId
                && obj.infraestruturaId == item.infraestruturaId
                && obj.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE));

            const destroy = async () => this.data.model.cotasTransferencia.splice(objIndex, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a transferência?', destroy)
        },
        getCotaAtribuida(unidade) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = this.data.model.cotasLaboratorio

            if (cota) {

                cota.map(item => item.cotaLaboratorio.map(unidadeSolicitante => {


                    this.cotaAtribuida = unidadeSolicitante.unidadeSolicitante.filter(field =>
                        field.unidadeSolicitanteId == unidade.unidadeId
                        && field.infraestruturaSolicitanteId == unidade.infraestruturaId
                        ).reduce((sum, element) => {

                            if (element.cota > 0 || element.cota > "0,00") {

                                sum = sum + 1;
                            }

                        return sum
                    },0)

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida

                    Object.keys(unidadeSolicitante).forEach(a => {

                        if (a == "exames") {

                        unidadeSolicitante[a].map(exames => {

                                this.cotaAtribuida = exames.unidadeSolicitante.filter(field =>
                                    field.unidadeSolicitanteId == unidade.unidadeId
                                    && field.infraestruturaSolicitanteId == unidade.infraestruturaId
                                    ).reduce((sum, element) => {

                                        if (element.cota > 0 || element.cota > "0,00") {

                                            sum = sum + 1;
                                        }

                                    return sum
                                },0)

                                this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                            })
                        }
                    })
                }))
            }

            if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 2)
            } else {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 0)
            }
        },
        handleClearFilter() {
            this.filter = null
            this.model.cotaMes = null
            this.model.cotaAno = null
        },
        handleClearFilterTransferencia() {
            this.filterTransferencia = null
            this.model.transferenciaAno = null
            this.model.transferenciaMes = null
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    let destinoCotaValor = this.formatMoney(item.destinoCotaValor, 2)
                    let cotaTotal = this.formatSumMoney(destinoCotaValor) + this.formatSumMoney(cotaExame)

                    return this.formatMoney(cotaTotal, 2)

                } else {

                    return item.destinoCotaValor
                }

            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return Number(item.destinoCotaQuantidade) + cotaExame
            }
        }
    },
    props: {
        data: { type: Object, required: true },
        itemsUnidadeSolicitante: { type: Array, required: true },
        itemsCotasTransferenciaUnidade: { type: Array, required: true },
    },
    mixins: [ repository, object, data, error, formats ],
}
</script>